import {
  INITIAL_PAYLOAD,
  IInitialPayloadAction,
} from '../types/initialPayload';

export const fetched = (): IInitialPayloadAction => ({
  type: INITIAL_PAYLOAD,
  payload: true,
});

export const reset = (): IInitialPayloadAction => ({
  type: INITIAL_PAYLOAD,
  payload: false,
});
